import { ibmClientId, individualRatesApi } from '../util/api';
import { isValidZipcode, ZIP_CODE_ERROR, ZipResponse } from '../util/zipcode';

export async function getZipcodeInfo(zipcode: string | undefined): Promise<ZipResponse[] | null> {
    if (!isValidZipcode(zipcode)) {
        return [{ reason: ZIP_CODE_ERROR }];
    }
    const res = await fetch(`${individualRatesApi}?zip=${zipcode}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-IBM-Client-ID': ibmClientId,
        },
    });
    if (!res.ok) {
        throw new Error(`error getting zip code info for ${zipcode}. ${res.statusText}`);
    }
    const data = await res.json();
    return data;
}
